import axios from 'axios';
import { MDBFileUpload } from "mdb-react-file-upload";
import {
  MDBAlert,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';

function ImageUpload({ pictureId, user, setShowUserProfileModal, onUsersUpdate, onDomainUsersUpdate}) {
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
 
  const { uid} = useContext(UserProfileContext);
  const {setAvatar} = useContext(NavbarContext);
  const [image, setImage] = useState();
  const domainId = localStorage.getItem('DOMAIN');
  const handleFileUpload = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    let imageName = '';

    if (file) {
      const renamedFile = new File([file], file.name, { type: file.type });
      formData.append('file', renamedFile);
      imageName = renamedFile.name;
    }

    let updatedImage;
    if (file) {
      updatedImage = { name: file.name, type: user ? 'avatar' : file.type, domains: [domainId] };
      const imageData = new File([JSON.stringify(updatedImage)], "image", { type: "application/json" });
      formData.append('image', imageData);
    }

    setFile(null);
    let endpoint = user ? `${baseUrl}/imgs/forUser` : `${baseUrl}/imgs/domainid/${domainId}`;
 

    const method = 'post';

    try {
      const response = await axios({
        method: method,
        url: endpoint,
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
      });

      if (response && response.data) {
        setImage(response.data);
      
        setAvatar(response.data.url);
        console.log("before update ", user);
        const updatedUserProfile = {
          ...user,
          
          picture: response.data.url,
          uid: user.uid ? user.uid : uid

        };
        console.log("after update", updatedUserProfile);
        onUsersUpdate && onUsersUpdate(updatedUserProfile);
        onDomainUsersUpdate && onDomainUsersUpdate(updatedUserProfile, false);
        
      }
      console.log("image response data :", response.data);
      setImage(response.data); // set image state to the uploaded image data
      setFileKey(prevKey => prevKey + 1);
      setShowUserProfileModal && setShowUserProfileModal(false)

    } catch (error) {
      console.error(error);
    }
    finally { setFile(null) }
  };


    const fetchImage = useCallback(async () => {
    try {
      let imageId = pictureId;
      if (pictureId.startsWith("https")) {
        imageId = pictureId.split('/').pop();
      }
      const response = await axios.get(`${baseUrl}/imgs/${imageId}`);
      if (response.status === 200) {
        setImage(response.data);
      }
    }
    catch (error) {
      setImage(null);
      console.error(error);
    }
  },[baseUrl, pictureId]);
 useEffect(() => {
    if (pictureId) {
      fetchImage();
    }

  }, [baseUrl, fetchImage, pictureId]);
  const fileInput = useRef(null);
  const [imageToRemove, setImageToRemove] = useState(null);

  const handleFileChange = (event) => {
    if (event) {
      let selectedFile = event;
      setFile(selectedFile[0]);
      setImage(selectedFile[0]); // Set the image state with the file object
    } else {
      setFile(null);
      setImage(null);
    }
  };

  const [fileKey, setFileKey] = useState(0);

  const [file, setFile] = useState(null);

  const handleFileRemoveConfirmation = (imageUrl) => {
    setShowConfirmAlert(true);
    setImageToRemove(imageUrl);

    setFile(null);
    setImage(null);
    setFileKey(prevKey => prevKey + 1);
  };

  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const handleFileRemove = async () => {
    setShowConfirmAlert(false); // Close the confirmation alert
    if (imageToRemove) {
      // Now use imageId in your axios.delete...
      try {
        await axios.delete(`${baseUrl}/imgs/${pictureId}`);
        setImage('');
      } catch (error) {
        console.error(error);
      }
    }
    setImageToRemove(null); // Reset imageToRemove after it's removed
    // Reset imageId after it's removed
  };
  const toggleShowConfirmAlert = () => {
    setShowConfirmAlert(!showConfirmAlert);
    setTimeout(() => {
      setShowConfirmAlert(false);
    }, 3000);

  };
  let alertProperties = {};
  let alertIcon = '';
  let alertBtn = '';

  if (showConfirmAlert) {
    alertProperties = {
      show: true,
      className: 'm-1',
      color: 'success',
      onClick: toggleShowConfirmAlert,
    };
    alertIcon = 'fas fa-check-circle me-3';
    alertBtn = (
      <div>

        <MDBBtn className='ms-2 me-2' onClick={handleFileRemove}>Yes</MDBBtn>
        <MDBBtn onClick={() => setShowConfirmAlert(false)}>No</MDBBtn>
      </div>
    );
  }

  return (
    <>
      {alertProperties.show && (
        <MDBAlert {...alertProperties} style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999, width: 'auto', maxWidth: '90%' }}>
          <i className={alertIcon}></i>{alertBtn}
        </MDBAlert>
      )}

      <section className='mt-2'>
        <MDBRow className="grainy-gradient-intro justify-content-center">
          <MDBCol className="mb-4 mb-md-0">
            <MDBCard className="mb-2" >
           {user && <MDBCardHeader className="card-header py-3">
              <strong>{user?.uid || uid} @ {user?.myDomainName}</strong>
              </MDBCardHeader>}
        
             
              <MDBCardBody>
                <form action="">
                  <MDBRow>
                    <div className="d-flex justify-content-center mb-4">
                      {image && image.url && <img src={`${image.url}?${Date.now()}`} className="shadow-1 mb-3" style={{ width: "250px", height: "300px" }} alt=' '/>}
                    </div>
                  </MDBRow>
                  <MDBRow>
                    <MDBFileUpload
                      key={fileKey}
                      ref={fileInput}
                      className="mb-4"
                      onChange={handleFileChange}
                      onRemove={() => handleFileRemoveConfirmation(image)}
                    />
                  </MDBRow>
                  <MDBCol className="d-flex justify-content-center">
                    <MDBBtn type="submit" onClick={handleFileUpload} disabled={!file}>
                      Upload
                    </MDBBtn>
                  </MDBCol>
                </form>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </section>
    </>
  );
}

ImageUpload.propTypes = {
  setImages: PropTypes.func,
  baseUrl: PropTypes.string.isRequired,
  pictureId: PropTypes.string,
  domainId: PropTypes.string,
  user: PropTypes.object,
  setShowUserProfileModal: PropTypes.func,
  onUsersUpdate: PropTypes.func,
  onDomainUsersUpdate: PropTypes.func,
}

export default ImageUpload;
